import { HiOutlineDocumentDownload } from "react-icons/hi";
import "./DownloadAttachment.css";

const DownloadAttachment = ({ fileUrl, fileName }) => {
  return (
    <a
      href={fileUrl}
      download={fileName}
      target="_blank"
      rel="noopener noreferrer"
      title="Download file"
      className="download-attachment"
    >
      <div className="preview-area">
        <HiOutlineDocumentDownload  className="file-icon" />
        <div className="download-overlay"></div>
      </div>
      <div className="file-info">
        <div className="file-name" title={fileName}>
          {fileName}
        </div>
      </div>
    </a>
  );
};

export default DownloadAttachment;
